module.exports = __webpack_public_path__ + "img/asus-vivobook-x512.25d2b54f.jpg";